<template>
  <div class="TaskManagement">
    <AppHeader :content="content"></AppHeader>
    <div style="display: flex">
      <AppBox class="leftBox" style="min-width: 300px">
        <el-button
            v-show="data.length === 0 && this.permissionCode.has('assist:task:manager')"
            size="mini"
            type="primary"
            plain
            @click="openTaskEdit"
        >
          新建任务
        </el-button>
        <el-tree
            lazy
            :data="data"
            :load="loadTask"
            :props="defaultProps"
            @node-click="handleNodeClick"
            ref="taskTree"
            node-key="id"
            :expand-on-click-node="false"
            :check-strictly="true"
            :highlight-current="true"
            :current-node-key="currentNodeKey"
            :render-content="renderTreeNode"
            @node-drop="handleDrop"
            draggable
        ></el-tree>
      </AppBox>
      <AppBox class="rightBox">
        <rich-text-edit></rich-text-edit>
      </AppBox>
    </div>
    <task-edit></task-edit>
  </div>
</template>
<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import TaskEdit from "@/pages/TaskManagement/TaskEdit.vue";
import OptionList from "@/pages/TaskManagement/OptionList.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import RichTextEdit from "@/pages/TaskManagement/RichTextEdit.vue";
import wikiCenter from "@/api/wikiCenter";

export default {
  name: "TaskManagement",
  components: {RichTextEdit, TaskEdit, AppHeader, AppBox},
  data() {
    return {
      content: "角色管理 | 任务管理",
      currentNodeKey: null,
      page: 1,
      size: 10,
      total: null,
      data: [],
      defaultProps: {
        children: "children",
        id: 0,
        name: "name",
      },
    };
  },
  computed: {
    ...mapState("user", ["permissionCode"]),
  },
  methods: {
    ...mapActions("taskCenter", []),
    ...mapMutations("taskCenter", [
      "showTaskEdit",
      "setType",
      "setTaskList",
      "setNode",
      "setSelectNode",
      "setAssistRoleId",
    ]),
    async handleDrop(draggingNode, dropNode, dropType) {
      let newParentKey = dropNode.parent?.key || 0;
      if ("inner" === dropType) {
        newParentKey = dropNode.key;
      }
      draggingNode.data.parent = newParentKey;
      await wikiCenter.moveAssistTask(draggingNode.key, dropNode.key, dropType);
    },
    loadTask(node, callback) {
      let assistRoleId = +this.$Base64.decode(this.$route.params.assistRoleId);
      this.setAssistRoleId(assistRoleId);
      wikiCenter.getAssistTaskList(assistRoleId, node?.key).then((res) => {
        let data = res.data;
        data.data.forEach((item) => {
          item.children = [];
        });
        callback(data.data);
        if (node.level === 0) {
          node.data.push(...data.data);
        } else {
          node.data.children = data.data;
        }

        this.total = data.total;
        this.page++;
      });
    },
    handleNodeClick(data, node) {
      this.setNode(data);
      this.setSelectNode(node);
    },
    openTaskEdit() {
      this.setType("parentMenu");
      this.setTaskList(this.data);
      this.showTaskEdit(true);
    },
    renderTreeNode(h, {node, data}) {
      return (
          <div style="display: flex;width: 100vw;">
            <p class="tree-name" title={data.name}>
              {data.name}
            </p>
            <OptionList selectNode={node} style="margin-left: auto;"></OptionList>
          </div>
      );
    },
  },
  async mounted() {
  },
};
</script>

<style lang="scss">
.TaskManagement {
  .tree-name {
    white-space: break-spaces;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 100px;
    max-width: 200px;
  }

  .el-tree-node__content {
    height: unset;
  }

  .leftBox {
    height: calc(100vh - 155px);
    width: calc(20vw);
    overflow-x: auto;
  }

  .rightBox {
    margin-left: 1vw;
    height: calc(100vh - 155px);
    width: calc(67vw);
  }
}
</style>
